<template>
	<router-view />
</template>
<script>
export default { name: 'ManageFeatures' };
</script>
